<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <div
            slot="header"
            style="display:flex; justify-content: space-between; align-items: center;"
          >
            <HeaderTitle title="Model: ">{{ selectedModel }}</HeaderTitle>
            <b-form-input
              style="display:inline-block; width:250px;float:right"
              v-model="searchQuery"
              type="search"
              id="filterInput"
              placeholder="Type to Search"
            ></b-form-input>
          </div>
          <b-row class="message_container">
            <p v-if="message !== ''">{{ message }}</p>
          </b-row>
          <b-row>
            <LoadingCard v-if="loadingData"></LoadingCard>
            <template v-else>
              <b-col
                v-for="model in filterItems(models)"
                lg="3"
                sm="6"
                :key="model.fns_part"
                style="padding: 5px;"
              >
                <a
                  class="locationLabels"
                  :href="'#/model/?part=' + model.fns_part"
                  >{{ model.model }}
                  <span v-if="model.backlog != 0" style="color:yellow">{{
                    model.backlog
                  }}</span></a
                >
              </b-col>
            </template>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import HeaderTitle from "../../../components/shared/HeaderTitle.vue";
import LoadingCard from "../../../components/shared/LoadingCard.vue";
import { modelStore, setIsFetching  } from '@/stores/modelStore';

export default {
  name: "AnalyticsByModel",
  data() {
    return {
      buttons: [
        { caption: "Fiber Gear" },
        { caption: "Line Gear" },
      ],
      title: "",
      models: [],
      searchQuery: "",
      loadingData: false,
      message: ""
    };
  },
  computed: {
    selectedModel() {
      return modelStore.selectedModel;
    },
    flagChanged() {
      return modelStore.isSpaced;
    },
  },
  watch: {
    selectedModel(value) {
      this.changeView(value);
    },
    flagChanged(value) {
      this.changeView(value);
    },
  },
  methods: {
    changeView(value) {
      setIsFetching(true);
      this.loadingData = true;
      this.message = "";
      this.title = value;
      let params = {};
      const productType = modelStore.selectedModel === 'All' ? '' : modelStore.selectedModel;
      params = {
        productType: productType,
        ...(modelStore.isSpaced ? { spaced: true} : {})
      };
      this.$http.get("api/comcast_arc/products/modelsByGroup.php", { params }).then(
        res => {
          if (res && res.data && res.data.length > 0) {
            this.models = res.data;
            this.message = "";
          } else {
            this.message = "Please select a model";
            this.models = [];
          }
          setIsFetching(false);
          this.loadingData = false;
        },
        err => {
          setIsFetching(false);
          this.loadingData = false;
          console.log(err);
        }
      );
    },
    filterItems: function(models) {
      var app = this;
      return models.filter(function(models) {
        let regex = new RegExp("(" + app.searchQuery + ")", "i");
        return models.model.match(regex);
      });
    }
  },
  mounted() {
    this.changeView("All");
  },
  components: { LoadingCard, HeaderTitle }
};
</script>

<style>
.message_container {
  display: flex;
  justify-content: center;
}
.mybtns {
  display: block !important;
  margin: auto;
}
.locationLabels {
  padding: 9px;
}
.loading {
  display: block !important;
  margin: auto !important;
}
</style>
